import { render, staticRenderFns } from "./CertInfo.vue?vue&type=template&id=4c07fc52&scoped=true&"
import script from "./CertInfo.vue?vue&type=script&lang=js&"
export * from "./CertInfo.vue?vue&type=script&lang=js&"
import style0 from "./CertInfo.vue?vue&type=style&index=0&id=4c07fc52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07fc52",
  null
  
)

export default component.exports